/**
 * Retorna a data atual no padrão iso
 * @returns {string} 'year-month-day'
 */
export function determinarDataMinima() {
  const [dia, mes, ano] = new Date().toLocaleDateString('pt-br').split('/')

  // Pad single-digit months, days, hours, and minutes with leading zeros
  const pad = num => num.toString().padStart(2, '0')

  // Construct the ISO 8601 datetime string manually
  const isoDate = `${ano}-${pad(mes)}-${pad(dia)}`

  return isoDate
}

function getCurrentTimeStringAdded30Minutes() {
  const date = new Date()

  date.setMinutes(date.getMinutes() + 1)

  return date.toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' })
}

/**
 * Retorna o tempo mínimo que deve ser selecionado.
 * @param {string} dateIso
 * @returns {string} 'hours:minutes:seconds'
 */
export function determinarTempoMinimo(dateIso) {
  if (!dateIso) {
    return getCurrentTimeStringAdded30Minutes()
  }

  const dataSelecionadaJaPassou = new Date() < new Date(dateIso)

  if (dataSelecionadaJaPassou) {
    return null
  }

  return getCurrentTimeStringAdded30Minutes()
}
